import { render, staticRenderFns } from "./FiscaisAsideSection.vue?vue&type=template&id=48619789&scoped=true"
import script from "./FiscaisAsideSection.vue?vue&type=script&lang=js"
export * from "./FiscaisAsideSection.vue?vue&type=script&lang=js"
import style0 from "./FiscaisAsideSection.vue?vue&type=style&index=0&id=48619789&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48619789",
  null
  
)

export default component.exports